import type { DialogCloseReason, DialogHeaderProps, DialogProps as DesignSystemDialogProps } from '@lmn/design-system';
import type { Brand } from '@/domainLogic/index.ts';
import { type CSSProperties, type ReactElement } from 'react';

type DialogProps = Omit<DesignSystemDialogProps, 'onClose' | 'header'>;

type ExtendedHeaderProps = Omit<DialogHeaderProps, 'element'> & {
  element?: string | ReactElement | null;
};

export type { DialogCloseReason };

export enum MODAL_THEME_VARIANTS {
  GRAY = 'gray',
  WHITE = 'white',
}

export enum MODAL_SIZES {
  XXL = 'XXL', // 736px
  XL = 'XL', // 600px
  L_EVO = 'L_EVO', // 520px
  L = 'L', // 480px
  M = 'M', // 400px
  S = 'S', // 375px
}

export type MODAL_SIZES_TYPE = MODAL_SIZES;

export type OpenxDialogProps = {
  brand: Brand;
  className?: string;
  disableAnimation?: boolean;
  disableBrowserHistoryNavigation?: boolean;
  id: string;
  isMobile: boolean;
  scrollShadows?: boolean;
  style?: CSSProperties;
  onClose: (e: object, reason: DialogCloseReason) => void;
  onCloseByBrowserHistory?: () => void;
  onOpenByBrowserHistory?: () => void;
  onFinallyHistoryBack?: () => void;
  variant?: MODAL_THEME_VARIANTS;
  size?: MODAL_SIZES_TYPE;
  header?: ExtendedHeaderProps;
} & DialogProps;
